import { ref } from 'vue'
import { dateUtils } from 'pangu-core/scan/common/index.js'

export default function useInputInvoiceScan({
  data,
  emit,
  beforeEmit,
  changeDisabled,
  invoiceData,
}) {
  // 获取扫描的条码后的流程
  const __scaning = async () => {
    try {
      __analysing()
    } catch (error) {
      console.log('--error-scaning: ', error?.message)
    }
  }

  // 解析识别条码
  const __analysing = async () => {
    // 开始扫码解析识别
    const res = parseInvoiceQrCode(data.code)
    console.log('解析识别后的结果1: ', res)

    res.changeDisabled = changeDisabled
    invoiceData.code = res.invoiceNumber
    emit('input', res)
    emit('on-scan', res)
    await beforeEmit(res)
  }

  // 获取扫描的条码
  const parsing = async (evt) => {
    let _code = evt.target.value // 获取扫码枪扫出的条码
    // _code ='０１，３１，、２５５１２００００００２７３５７９６６３，１２９３０．００，２０２５１１１３，、E818'
    // _code = '01,01,3702221130,04800054,888.8,20230517,68893455791285901076,727C'
    console.log('用扫码枪获取到的code', _code)

    const keycode = evt.keyCode || evt.which || evt.charCode
    console.log('捕获扫码后触发的事件: ', 'keycode-', keycode, '_code-', _code, 'evt-', evt)
    // eslint-disable-next-line vue/no-parsing-error
    // 排除某些电脑通过ASCII码直接输入分隔符， 的 ASCII 码: \x1D charCode: 29
    const regx = new RegExp(`${String.fromCharCode(29)}|\\x81`, 'g')
    if (regx.test(_code)) {
      evt.srcElement.value = evt.srcElement.value.replace(regx, '')
      _code = _code.replace(regx, '')
    }

    // Enter
    const isEneter = keycode === 13

    if (isEneter) {
      evt.srcElement.select()
      data.code = _code
      _code = null

      // 开始解析后逻辑处理
      await __scaning()
    }
  }

  const inputType = ref('password')
  const onFocus = () => {
    inputType.value = 'password'
    setTimeout(() => {
      inputType.value = 'text'
    })
  }

  // 清空识别文本框内容
  const clearInput = () => {
    data.code = ''
  }

  /**
   * 解析增值税发票二维码信息（兼容全角分隔符）
   * @param {string} qrCodeStr - 包含全角逗号、顿号或半角逗号的发票字符串
   * @returns {Object} 包含8个字段的解析结果对象（空字段返回空字符串）
   * 字段说明：
   * {
   *  fixedFlag：发票二维码标识，固定值
   *  type：发票种类
   *  invoiceCode：发票代码
   *  invoiceNumber：发票号码
   *  price：开票金额
   *  date：开票日期
   *  checkCode：发票校验码
   *  encryptCode：加密字符
   * }
   * @throws {Error} 当输入非字符串时抛出异常
   */
  const parseInvoiceQrCode = (qrCodeStr) => {
    // 基础校验：非空判断 + 类型校验
    if (!qrCodeStr || typeof qrCodeStr !== 'string') {
      return {
        invoiceNumber: qrCodeStr,
      }
    }

    // 替换所有分隔符为统一的半角逗号（全角逗号、顿号都视为分隔符）
    const unifiedDelimiterStr = qrCodeStr.replace(/[，、,]/g, ',')

    // 按半角逗号分割字段（连续逗号视为空字段）
    let fields = unifiedDelimiterStr.split(',')

    // 截取/补全为8个字段（不足补空，超出截断）
    fields = fields.slice(0, 8)
    while (fields.length < 8) {
      fields.push('')
    }

    // 全角字符转半角
    const halfWidthFields = fields.map((field) => fullToHalf(field))
    const [fixedFlag, type] = halfWidthFields

    // 判断是否是发票二维码数据
    const validationResult = validateInvoiceFields({
      fixedFlag,
      type,
    })
    if (!validationResult.valid) {
      //不是发票规则,默认返回字符串当发票号码
      return {
        invoiceNumber: qrCodeStr,
      }
    } else {
      // 发票种类代码映射表
      const invoiceTypeMap = {
        '01': '增值税专用发票',
        '04': '增值税普通发票',
        10: '增值税普通发票（电子）',
        '08': '增值税专用发票（电子）',
        31: '电子发票(增值税专用发票)',
      }

      // 处理金额字段
      const priceField = halfWidthFields[4]
      const price = priceField
        ? isNaN(parseFloat(priceField))
          ? priceField
          : parseFloat(priceField)
        : ''

      // 解析并返回8个字段
      return {
        fixedFlag: halfWidthFields[0] || '',
        invoiceType: {
          code: halfWidthFields[1] || '',
          name:
            invoiceTypeMap[halfWidthFields[1]] ||
            `未知发票类型（代码：${halfWidthFields[1] || '无'}）`,
        },
        invoiceCode: halfWidthFields[2] || '',
        invoiceNumber: halfWidthFields[3] || '',
        price: price,
        invoiceDate: halfWidthFields[5]
          ? dateUtils.formatHibcDate(halfWidthFields[5], 'YYYY-MM-DD')
          : '',
        checkCode: halfWidthFields[6] || '',
        encryptCode: halfWidthFields[7] || '',
      }
    }
  }
  /**
   * validateInvoiceFields()：校验发票字段是否符合规则
   * @param {Object} fields - 半角转换后需要校验的字段
   * @returns {Object} { valid: boolean, message: string }
   */
  function validateInvoiceFields({ fixedFlag, type }) {
    // 校验固定标识（第1字段必须是01）
    if (fixedFlag !== '01') {
      return {
        valid: false,
        message: '第1字段固定标识必须为"01"，不是发票二维码数据',
      }
    }
    // 校验发票种类代码（第2字段：必须是有效代码）
    const validTypeCodes = ['01', '04', '10', '08', '31']
    if (!validTypeCodes.includes(type) && type.trim() !== '') {
      return {
        valid: false,
        message: `第2字段发票种类代码"${type}"无效，不是发票二维码数据`,
      }
    }
    return { valid: true, message: '字段校验通过' }
  }

  /**
   * fullToHalf()：全角字符转半角
   * @param {string} str - 可能包含全角的字段值
   * @returns {string} 半角字符串
   */
  const fullToHalf = (str) => {
    if (str === '') return ''
    let result = ''
    for (let i = 0; i < str.length; i++) {
      const charCode = str.charCodeAt(i)

      if (charCode >= 65296 && charCode <= 65305) {
        // 全角数字 → 半角数字
        result += String.fromCharCode(charCode - 65248)
      } else if (
        (charCode >= 65313 && charCode <= 65338) ||
        (charCode >= 65345 && charCode <= 65370)
      ) {
        // 全角字母 → 半角字母
        result += String.fromCharCode(charCode - 65248)
      } else if (charCode === 65294) {
        // 全角点号 → 半角点号
        result += '.'
      } else if (
        (charCode >= 0xff01 && charCode <= 0xff0f) ||
        (charCode >= 0xff1a && charCode <= 0xff20) ||
        (charCode >= 0xff3b && charCode <= 0xff40) ||
        (charCode >= 0xff5b && charCode <= 0xff65)
      ) {
        // 其他全角符号 → 半角
        result += String.fromCharCode(charCode - 65248)
      } else {
        // 其他字符直接保留
        result += str.charAt(i)
      }
    }
    return result
  }

  return {
    parsing,
    clearInput,
    onFocus,
    inputType,
  }
}
